import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const generateMcpTokenFn = httpsCallable(functions, 'generateMcpToken', { timeout: 15000 });
const revokeMcpTokenFn   = httpsCallable(functions, 'revokeMcpToken',   { timeout: 15000 });

export async function generateMcpToken() {
  const result = await generateMcpTokenFn();
  return result.data.token;
}

export async function revokeMcpToken() {
  await revokeMcpTokenFn();
}
